import React, {useEffect, useState} from 'react';
import apiCalls from "../utils/apiCalls";
import utils from "../utils/utils";
import Loader from "../components/loader";
import ErrorMessage from "../components/errorMessage";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import OrderBatchBillPdf from "./orderBatchBillPdf";

const OrderBatchBill = ({match}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderBatch, setOrderBatch] = useState(null);
  const [marketplaces, setMarketplaces] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError(null);

    apiCalls.getOrders({
      orderBatchId: match.params.orderBatchId,
      token: match.params.token,
    })
      .then((result) => {
        if (result.data && result.data.orders) {
          setOrders(result.data.orders);
          return apiCalls.getMarketplaces({
            marketplaceIds: result.data.orders.map(o => o.marketplaceId).join(','),
          });
        }
      })
      .then((result) => {
        if (result.data && result.data.marketplaces) {
          setMarketplaces(result.data.marketplaces);
          return apiCalls.getOrderBatches({
            orderBatchId: match.params.orderBatchId,
          });
        }
      })
      .then((result) => {
        if (result.data && result.data.orderBatches) {
          setOrderBatch(result.data.orderBatches[0]);
          setLoading(false);
        }
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Loader show={loading}/>
      <ErrorMessage error={error}/>

      <div className="container order-batch-bill m-t-6">
        <div className="row">
          <div className="col-12">
            {
              orders.length && marketplaces.length && orderBatch? (
                <div>
                  <OrderBatchBillPdf orders={orders} marketplaces={marketplaces} orderBatch={orderBatch}/>
                </div>
              ): ''
            }
          </div>
        </div>
      </div>
    </>
  );
}

OrderBatchBill.propTypes = {};

OrderBatchBill.defaultProps = {};

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(mapStateToProps)(OrderBatchBill));